class UserData {
  constructor(data) {
    this.jwt = data.Jwt;
    this.idUserDetails = data.IdUserDetails;
    this.userId = data.UserId;
    this.name = data.Name;
    this.lastName = data.LastName;
    this.secondLastName = data.SecondLastName;
    this.email = data.Email;
    this.idLanguage = data.IdLanguage;
    this.idEmploye = data.IdEmploye;
    this.idEmployeNavigation = data.IdEmployeNavigation
      ? new Employe(data.IdEmployeNavigation)
      : null;
    this.idLanguageNavigation = data.IdLanguageNavigation
      ? new Language(data.IdLanguageNavigation)
      : null;
    this.user = data.User ? new User(data.User) : null;
  }
}

class Employe {
  constructor(data) {
    this.idEmploye = data.IdEmploye;
    this.noEmploye = data.NoEmploye;
    this.idEmployeType = data.IdEmployeType;
    this.name = data.Name;
    this.lastName = data.LastName;
    this.secondLastName = data.SecondLastName;
    this.curp = data.Curp;
    this.foto = data.Foto;
    this.idLocation = data.IdLocation;
    this.idActualLocation = data.IdActualLocation;
    this.status = data.Status;
    this.userId = data.UserId;
    this.regritationUserId = data.RegritationUserId;
    this.registrationDate = data.RegistrationDate;
    this.idActualLocationNavigation = data.IdActualLocationNavigation
      ? new ActualLocation(data.IdActualLocationNavigation)
      : null;
    this.idEmployeTypeNavigation = data.IdEmployeTypeNavigation
      ? new EmployeType(data.IdEmployeTypeNavigation)
      : null;
    this.idLocationNavigation = data.IdLocationNavigation
      ? new Location(data.IdLocationNavigation)
      : null;
    this.regritationUser = data.RegritationUser;
    this.user = data.User;
    this.userDetails = data.UserDetails;
  }
}

class Language {
  constructor(data) {
    this.idLanguage = data.IdLanguage;
    this.descripcion = data.Descripcion;
    this.estatus = data.Estatus;
    this.claveIdioma = data.ClaveIdioma;
    this.traduccionLenguajes = data.TraduccionLenguajes;
    this.userDetails = data.UserDetails;
  }
}

class User {
  constructor(data) {
    this.id = data.Id;
    this.userName = data.UserName;
    this.normalizedUserName = data.NormalizedUserName;
    this.email = data.Email;
    this.normalizedEmail = data.NormalizedEmail;
    this.emailConfirmed = data.EmailConfirmed;
    this.passwordHash = data.PasswordHash;
    this.securityStamp = data.SecurityStamp;
    this.concurrencyStamp = data.ConcurrencyStamp;
    this.phoneNumber = data.PhoneNumber;
    this.phoneNumberConfirmed = data.PhoneNumberConfirmed;
    this.twoFactorEnabled = data.TwoFactorEnabled;
    this.lockoutEnd = data.LockoutEnd;
    this.lockoutEnabled = data.LockoutEnabled;
    this.accessFailedCount = data.AccessFailedCount;
    this.aspNetUserClaims = data.AspNetUserClaims;
    this.aspNetUserLogins = data.AspNetUserLogins;
    this.aspNetUserTokens = data.AspNetUserTokens;
    this.employeRegritationUsers = data.EmployeRegritationUsers;
    this.employeUsers = data.EmployeUsers;
    this.errorLogApps = data.ErrorLogApps;
    this.generalInspections = data.GeneralInspections;
    this.generalRevisionRevisionPointImages =
      data.GeneralRevisionRevisionPointImages;
    this.models = data.Models;
    this.permisosWebUsuarios =
      data.PermisosWebUsuarios !== null
        ? data.PermisosWebUsuarios.map((item) => new PermisosWebUsuarios(item))
        : null;
    this.revisionPoints = data.RevisionPoints;
    this.unitTypes = data.UnitTypes;
    this.userDetails = data.UserDetails;
    this.years = data.Years;
    this.roles = data.Roles;
    this.foto = data.Foto;
  }
}

class ActualLocation {
  constructor(data) {
    this.idActualLocation = data.IdActualLocation;
    // Otras propiedades de ActualLocation
  }
}

class EmployeType {
  constructor(data) {
    this.idEmployeType = data.IdEmployeType;
    // Otras propiedades de EmployeType
  }
}

class Location {
  constructor(data) {
    this.idLocation = data.IdLocation;
    // Otras propiedades de Location
  }
}

class PermisosWebUsuarios {
  constructor(data) {
    this.idPermisoWebUsuario = data.IdPermisoWebUsuario;
    this.idUsuario = data.IdUsuario;
    this.idPermisoWeb = data.IdPermisoWeb;
    this.esInicio = data.EsInicio;
    this.estatus = data.Estatus;
    this.controlador = data.controlador;
    this.idPermisoWebNavigation = new PermisoWeb(data.IdPermisoWebNavigation);
    this.idUsuarioNavigation = data.IdUsuarioNavigation;
  }
}

class PermisoWeb {
  constructor(data) {
    this.idPermisoWeb = data.IdPermisoWeb;
    this.descripcion = data.Descripcion;
    this.descripcionOtroLenguaje = data.DescripcionOtroLenguaje;
    this.idPermisoPadre = data.IdPermisoPadre;
    this.accion = data.Accion;
    this.controlador = data.Controlador;
    this.estatus = data.Estatus;
    this.orden = data.Orden;
    this.descripcionAccion = data.DescripcionAccion;
    this.descripcionAccionOtroLenguaje = data.DescripcionAccionOtroLenguaje;
    this.icono = data.Icono;
    this.mostrarEnMenu = data.MostrarEnMenu;
    this.isCliente = data.IsCliente;
    this.idPermisoPadreNavigation = data.IdPermisoPadreNavigation;
    this.inverseIdPermisoPadreNavigation =
      data.InverseIdPermisoPadreNavigation !== null
        ? data.InverseIdPermisoPadreNavigation.map(
            (item) => new InversePermisoPadre(item)
          )
        : null;
    this.permisoWebRols = data.PermisoWebRols;
    this.permisosWebUsuarios = data.PermisosWebUsuarios;
  }
}

class InversePermisoPadre {
  constructor(data) {
    this.idPermisoWeb = data.IdPermisoWeb;
    this.descripcion = data.Descripcion;
    this.descripcionOtroLenguaje = data.DescripcionOtroLenguaje;
    this.idPermisoPadre = data.IdPermisoPadre;
    this.accion = data.Accion;
    this.controlador = data.Controlador;
    this.estatus = data.Estatus;
    this.orden = data.Orden;
    this.descripcionAccion = data.DescripcionAccion;
    this.descripcionAccionOtroLenguaje = data.DescripcionAccionOtroLenguaje;
    this.icono = data.Icono;
    this.mostrarEnMenu = data.MostrarEnMenu;
    this.isCliente = data.IsCliente;
    this.idPermisoPadreNavigation = data.IdPermisoPadreNavigation;
    this.inverseIdPermisoPadreNavigation =
      this.inverseIdPermisoPadreNavigation =
        data.InverseIdPermisoPadreNavigation !== null
          ? data.InverseIdPermisoPadreNavigation.map(
              (item) => new InversePermisoPadreNavigation(item)
            )
          : null;
    this.permisoWebRols = data.PermisoWebRols;
    this.permisosWebUsuarios = data.PermisosWebUsuarios;
  }
}

class InversePermisoPadreNavigation {
  constructor(data) {
    this.idPermisoWeb = data.IdPermisoWeb;
    this.descripcion = data.Descripcion;
    this.descripcionOtroLenguaje = data.DescripcionOtroLenguaje;
    this.idPermisoPadre = data.IdPermisoPadre;
    this.accion = data.Accion;
    this.controlador = data.Controlador;
    this.estatus = data.Estatus;
    this.orden = data.Orden;
    this.descripcionAccion = data.DescripcionAccion;
    this.descripcionAccionOtroLenguaje = data.DescripcionAccionOtroLenguaje;
    this.icono = data.Icono;
    this.mostrarEnMenu = data.MostrarEnMenu;
    this.isCliente = data.IsCliente;
    this.idPermisoPadreNavigation = data.IdPermisoPadreNavigation;
    this.inverseIdPermisoPadreNavigation = data.InverseIdPermisoPadreNavigation;
    this.permisoWebRols = data.PermisoWebRols;
    this.permisosWebUsuarios = data.PermisosWebUsuarios;
  }
}

export default UserData;
